export default {
  FETCH_LAST_HUB_PAGE_REVISIONS_REQUEST: 'FETCH_LAST_HUB_PAGE_REVISIONS_REQUEST',
  FETCH_LAST_HUB_PAGE_REVISIONS_SUCCESS: 'FETCH_LAST_HUB_PAGE_REVISIONS_SUCCESS',
  FETCH_LAST_HUB_PAGE_REVISIONS_FAILURE: 'FETCH_LAST_HUB_PAGE_REVISIONS_FAILURE',
  FETCH_LAST_PUBLISHED_HUB_PAGE_REVISIONS_REQUEST: 'FETCH_LAST_PUBLISHED_HUB_PAGE_REVISIONS_REQUEST',
  FETCH_LAST_PUBLISHED_HUB_PAGE_REVISIONS_SUCCESS: 'FETCH_LAST_PUBLISHED_HUB_PAGE_REVISIONS_SUCCESS',
  FETCH_LAST_PUBLISHED_HUB_PAGE_REVISIONS_FAILURE: 'FETCH_LAST_PUBLISHED_HUB_PAGE_REVISIONS_FAILURE'
}
